import { render, staticRenderFns } from "./TaxCodeSelect.vue?vue&type=template&id=640bb1df&"
import script from "./TaxCodeSelect.vue?vue&type=script&lang=ts&"
export * from "./TaxCodeSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('640bb1df')) {
      api.createRecord('640bb1df', component.options)
    } else {
      api.reload('640bb1df', component.options)
    }
    module.hot.accept("./TaxCodeSelect.vue?vue&type=template&id=640bb1df&", function () {
      api.rerender('640bb1df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/custom/select/TaxCodeSelect.vue"
export default component.exports